import { render } from "./ChatPage.vue?vue&type=template&id=d0feda14&ts=true"
import script from "./ChatPage.vue?vue&type=script&lang=ts"
export * from "./ChatPage.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__